'use strict';

wbApp.factory('rfidCardsSvc', ['$resource', '$q', 'repositorySvc', 'securitySvc', 'localStorageService',
    function ($resource, $q, repositorySvc, securitySvc, localStorageService) {
        var RfidCards = $resource('/Api/RfidCard/:id', {}, {
            'getAllLogs': { method: 'GET', isArray: true, url: '/Api/RfidCard/GetAllLogs' },
            'getAllUploadContacts': { method: 'GET', isArray: true, url: '/Api/RfidCard/GetAllUploadContacts' },
            'insert': { method: 'POST', url: '/Api/RfidCard/Insert' },
            'update': { method: 'POST', url: '/Api/RfidCard/Update' },
            'delete': { method: 'POST', url: '/Api/RfidCard/Delete' },
            'getRegisteredStudentsForPeriod': { method: 'GET', isArray: true, url: '/Api/RfidCard/GetRegisteredStudentsForPeriod' },
            'getRegisteredEmployeesForPeriod': { method: 'GET', isArray: true, url: '/Api/RfidCard/GetRegisteredEmployeesForPeriod' },
            'getMPSVAttendanceReport': { method: 'POST', url: '/Api/RfidCard/GetMPSVAttendanceReport' },
            'getMPSVNurseryAttendanceReport': { method: 'POST', url: '/Api/RfidCard/GetMPSVNurseryAttendanceReport' },
            'supportReplaceRange': { method: 'POST', url: '/restapi/rfid-card-logs/support/replace-range' },
            'supportDeleteUserInRange': { method: 'POST', isArray: true, url: '/restapi/rfid-card-logs/support/delete-user-in-range' },
            'supportReplaceUserInRange': { method: 'POST', isArray: true, url: '/restapi/rfid-card-logs/support/replace-user-in-range' },
            'supportShiftOriginEventInRange': { method: 'POST', url: '/restapi/rfid-card-logs/support/shift-origin-event-in-range' },
        });

        function getAllLogsAsync(fromDate, toDate) {
            var res = [];
            res.$promise = $q(function (resolve, reject) {
                repositorySvc.customGet('getAllLogs', RfidCards, {
                    fromDate: fromDate,
                    toDate: toDate
                }).$promise.then(function (dto) {
                    if (securitySvc.isInRole('RfidCardLog.Update')) {
                        res.push.apply(res, dto);
                        resolve(dto);
                    } else {
                        var filtered = _.filter(dto, function(row) {
                            return !row.isDeleted || (row.isDeleted && !String.prototype.isNullOrWhitespace(row.description));
                        });
                        res.push.apply(res, filtered);
                        resolve(filtered);
                    }
                }, function (rejectReason) {
                    reject(rejectReason);
                });
            });

            return res;
        }

        function getAllUploadContacts(fromDate, toDate) {
            return repositorySvc.customGet('getAllUploadContacts', RfidCards, {
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function createNew() {
            var model = {
                rfidCardLogID: 0,
                rfidCardLogUploadContactID: null,
                rfidCardLogOverrideID: null,
                deviceSerialNumber: null,
                userID: null,
                userIDType: 0,
                eventType: 39,
                subEvent: 47,
                eventTime: moment().toDate(),
                operatorFullName: null,
                operatorAddress: null,
                operatorEmail: null,
                operatorPhone: null,
                studentFullName: null,
                uploadedAt: null,
                isDeleted: false
            };

            if (localStorageService.isSupported) {
                model.userID = localStorageService.get('lastRfidCardUserID');
                model.userIDType = localStorageService.get('lastRfidCardUserIDType') || 0;
                model.deviceSerialNumber = localStorageService.get('lastRfidCardDeviceSerialNumber');
            }

            return model;
        }

        function insert(data, collection, successCallback, errorCallback) {

            if (!data.rfidCardLogOverrideID) {
                data.rfidCardLogOverrideID = 0;
            }

            // Save for later
            if (localStorageService.isSupported) {
                localStorageService.set('lastRfidCardUserID', data.userID);
                localStorageService.set('lastRfidCardUserIDType', data.userIDType);
                localStorageService.set('lastRfidCardDeviceSerialNumber', data.deviceSerialNumber);
            }

            repositorySvc.insert(
                RfidCards,          // $resource
                collection,         // collection
                data,               // entity
                successCallback,
                errorCallback,
                'rfidCardLogID');
        }

        function update(data, collection, successCallback, errorCallback) {

            if (!data.rfidCardLogOverrideID) {
                data.rfidCardLogOverrideID = 0;
            }

            repositorySvc.update(
                RfidCards,           // $resource
                collection,          // collection
                data,                // entity
                successCallback,
                errorCallback,
                'rfidCardLogID');
        }

        function remove(data, collection, successCallback, errorCallback) {

            var id = data.rfidCardLogID;

            function success(result) {

                if (!!result.rfidCardLogID) {
                    // Update soft deleted record in the collection
                    repositorySvc.entityUpdated(collection, result, 'rfidCardLogID');
                }  else {
                    // This is a real delete 
                    repositorySvc.entityRemoved(collection, id, 'rfidCardLogID');
                }

                if (successCallback) {
                    successCallback(result);
                }
            }

            repositorySvc.remove(
                RfidCards,           // $resource
                null,               // collection
                data,               // entity
                success,            // successCallback
                errorCallback,
                {
                    id: data.rfidCardLogID,
                    description: data.description
                },
                'rfidCardLogID');
        }

        function reset(data, collection, successCallback, errorCallback) {

            var isRemove = !data.rfidCardLogUploadContactID;
            data.rfidCardLogOverrideID = null;

            var id = data.rfidCardLogID;

            function success(result) {
                if (isRemove) {
                    // This is a real delete 
                    repositorySvc.entityRemoved(collection, id, 'rfidCardLogID');
                } else {
                    repositorySvc.entityUpdated(collection, result, 'rfidCardLogID');
                }

                if (successCallback) {
                    successCallback(result);
                }
            }

            repositorySvc.update(
                RfidCards,           // $resource
                null,                // collection
                data,                // entity
                success,
                errorCallback,
                'rfidCardLogID');
        }

        function getRegisteredStudentsForPeriodAsync(fromDate, toDate) {
            return repositorySvc.customGet('getRegisteredStudentsForPeriod', RfidCards, {
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function getRegisteredEmployeesForPeriodAsync(fromDate, toDate) {
            return repositorySvc.customGet('getRegisteredEmployeesForPeriod', RfidCards, {
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function getMPSVAttendanceReportAsync(students, employees, fromDate, toDate, compatibility, group) {
            return repositorySvc.customPost('getMPSVAttendanceReport', RfidCards, {
                students: students,
                employees: employees,
                fromDate: fromDate,
                toDate: toDate,
                compatibility: compatibility,
                group: group
            });
        }

        function supportReplaceRange(model) {
            return repositorySvc.customPost('supportReplaceRange', RfidCards, model);
        }

        function supportDeleteUserInRange(model) {
            return repositorySvc.customPost('supportDeleteUserInRange', RfidCards, model);
        }

        function supportReplaceUserInRange(model) {
            return repositorySvc.customPost('supportReplaceUserInRange', RfidCards, model);
        }

        function supportShiftOriginEventInRange(model) {
            return repositorySvc.customPost('supportShiftOriginEventInRange', RfidCards, model);
        }


        function getMPSVNurseryAttendanceReportAsync(students, employees, fromDate, toDate, compatibility, group) {
            return repositorySvc.customPost('getMPSVNurseryAttendanceReport', RfidCards, {
                students: students,
                employees: employees,
                fromDate: fromDate,
                toDate: toDate,
                compatibility: compatibility,
                group: group
            });
        }

        return {
            getAllLogsAsync: getAllLogsAsync,
            getAllUploadContacts: getAllUploadContacts,
            insert: insert,
            update: update,
            remove: remove,
            reset: reset,
            createNew: createNew,
            getRegisteredStudentsForPeriodAsync: getRegisteredStudentsForPeriodAsync,
            getRegisteredEmployeesForPeriodAsync: getRegisteredEmployeesForPeriodAsync,
            getMPSVAttendanceReportAsync: getMPSVAttendanceReportAsync,
            getMPSVNurseryAttendanceReportAsync: getMPSVNurseryAttendanceReportAsync,
            supportReplaceRange: supportReplaceRange,
            supportDeleteUserInRange: supportDeleteUserInRange,
            supportReplaceUserInRange: supportReplaceUserInRange,
            supportShiftOriginEventInRange: supportShiftOriginEventInRange
        }
    }]);